/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DemoRefreshStatusResponseStatusEnum } from './DemoRefreshStatusResponseStatusEnum';
import {
    DemoRefreshStatusResponseStatusEnumFromJSON,
    DemoRefreshStatusResponseStatusEnumFromJSONTyped,
    DemoRefreshStatusResponseStatusEnumToJSON,
    DemoRefreshStatusResponseStatusEnumToJSONTyped,
} from './DemoRefreshStatusResponseStatusEnum';

/**
 * 
 * @export
 * @interface DemoRefreshStatusResponse
 */
export interface DemoRefreshStatusResponse {
    /**
     * 
     * @type {DemoRefreshStatusResponseStatusEnum}
     * @memberof DemoRefreshStatusResponse
     */
    status: DemoRefreshStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DemoRefreshStatusResponse
     */
    conversationId?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DemoRefreshStatusResponse
     */
    proposalIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof DemoRefreshStatusResponse
     */
    fallback?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoRefreshStatusResponse
     */
    error?: string;
}



/**
 * Check if a given object implements the DemoRefreshStatusResponse interface.
 */
export function instanceOfDemoRefreshStatusResponse(value: object): value is DemoRefreshStatusResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function DemoRefreshStatusResponseFromJSON(json: any): DemoRefreshStatusResponse {
    return DemoRefreshStatusResponseFromJSONTyped(json, false);
}

export function DemoRefreshStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoRefreshStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': DemoRefreshStatusResponseStatusEnumFromJSON(json['status']),
        'conversationId': json['conversation_id'] == null ? undefined : json['conversation_id'],
        'proposalIds': json['proposal_ids'] == null ? undefined : json['proposal_ids'],
        'fallback': json['fallback'] == null ? undefined : json['fallback'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

  export function DemoRefreshStatusResponseToJSON(json: any): DemoRefreshStatusResponse {
      return DemoRefreshStatusResponseToJSONTyped(json, false);
  }

  export function DemoRefreshStatusResponseToJSONTyped(value?: DemoRefreshStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': DemoRefreshStatusResponseStatusEnumToJSON(value['status']),
        'conversation_id': value['conversationId'],
        'proposal_ids': value['proposalIds'],
        'fallback': value['fallback'],
        'error': value['error'],
    };
}

